import firebase, {db} from 'configs/firebase'
import mapValues from 'lodash/mapValues'
import isFunction from 'lodash/isFunction'
import get from 'lodash/get'

export function formatTimestamp(data) {
  return mapValues(data, val =>
    isFunction(get(val, 'toMillis')) ? val.toMillis() : val
  )
}

export const timestampConverter = {
  fromFirestore: (snapshot, options) => formatTimestamp(snapshot.data(options)),
}

export async function createDocument(collection, data) {
  if (!collection || !data) return null

  const newDocumentRef = data.uid
    ? db.doc(`${collection}/${data.uid}`)
    : db.collection(collection).doc()
  const uid = newDocumentRef.id
  const createdAt = firebase.firestore.FieldValue.serverTimestamp()

  const finalData = {...data, uid, createdAt}

  try {
    await newDocumentRef.set(finalData)
  } catch (err) {
    console.warn('error creating document', err)
    return null
  }

  return finalData
}

export async function updateDocument(collection, id, data) {
  if (!collection || !id || !data) return null

  const documentRef = db.collection(collection).doc(id)
  const updatedAt = firebase.firestore.FieldValue.serverTimestamp()

  const updates = {...data, updatedAt}

  try {
    await documentRef.update(updates)
  } catch (err) {
    console.warn('error updating document', err)
    return null
  }

  return {...data, updatedAt}
}

export async function getDocumentById(collection, id) {
  if (!id || !collection) return null

  let data = null
  try {
    const doc = await db.doc(`${collection}/${id}`).get()
    if (doc.exists) data = doc.data()
  } catch (err) {
    console.warn('error fetching document', err)
    return null
  }

  if (!data) return null

  return formatTimestamp(data)
}
